import { render } from "./Typepolicie.vue?vue&type=template&id=6885564a&scoped=true"
import script from "./Typepolicie.vue?vue&type=script&lang=js"
export * from "./Typepolicie.vue?vue&type=script&lang=js"

import "./Typepolicie.vue?vue&type=style&index=0&id=6885564a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6885564a"

export default script